<template>
  <div class="email-verification-container">
    <div class="email-verification" :class="activeSideClass">
      <div class="radio-wrapper" ref="radioWrap">
        <outlined-container :active="pickedMail === 'oldMail'"
                            class="first-radio">
          <div class="single-radio-wrapper">
            <base-radio v-model="pickedMail"
                        value="oldMail"
                        name="pickMail"
                        position="right"
                        vertical-align="center"
                        class="radio-single">
              <h4 class="heading">{{ $t('registration.oldMailCheckboxLabel') }}</h4>
              <p class="email">{{ email }}</p>
            </base-radio>
          </div>
        </outlined-container>
        <outlined-container :active="pickedMail === 'newMail'">
          <div class="single-radio-wrapper">
            <base-radio v-model="pickedMail"
                        value="newMail"
                        name="pickMail"
                        position="right"
                        vertical-align="center"
                        class="radio-single">
              <h4 class="heading">{{ $t('registration.newMailCheckboxLabel.line1') }}<br>
                {{ $t('registration.newMailCheckboxLabel.line2') }}</h4>
            </base-radio>
          </div>
        </outlined-container>

        <base-button class="change-step-btn" @click="toggleFormSide('passwordWrap')">
          {{ $t('common.continue') }}
        </base-button>
      </div>
      <div class="password-wrapper" ref="passwordWrap">
        <transition name="fade" mode="out-in">
          <div v-if="pickedMail === 'oldMail'" :key="'oldMailDiv'">
            <validation-observer tag="form"
                                 ref="emailVerOldMail"
                                 @submit.prevent="loginWithOldMail">
              <ul class="custom-list">
                <li>{{ $t('registration.oldMailDescription') }}</li>
              </ul>
              <base-v-input
                v-model="oldMailPassword"
                id="passwordOldMail"
                name="passwordOldMail"
                rules="required"
                reveal-password
                type="password"
                maxlength="20"
                :submited="oldMailSubmitted"
                :label="$t('registration.oldPasswordLabel')"
                vid="passwordOldMail"/>
              <a class="back-link" :href="forgottenPasswordLink" @click="forgottenPasswordEvent">{{ $t('registration.forgotPassword') }}</a>
              <base-button class="continue-btn"
                           :disabled="!verificationMailInputFilled || buttonDisabled"
                           type="submit">
                {{ $t('common.continue') }}
              </base-button>
            </validation-observer>
          </div>
          <div v-else :key="'newMailDiv'">
            <ul class="custom-list">
              <li>{{ $t('registration.newMailDescription.line1') }} <span class="email">{{ email }}</span></li>
              <li>{{ $t('registration.newMailDescription.line2') }}</li>
              <li>{{ $t('registration.newMailDescription.line3') }}</li>
            </ul>
            <validation-observer tag="form"
                                 ref="emailVerNewMail"
                                 @submit.prevent="loginWithNewMail">
              <base-v-input
                ref="inputPassword"
                v-model="newMailPassword"
                id="passwordNewMail"
                name="passwordNewMail"
                rules="required"
                :submitted="newMailSubmitted"
                :label="$t('registration.oldPasswordLabel')"
                reveal-password
                type="password"
                maxlength="20"
                vid="passwordNewMail"/>
              <a class="back-link" :href="forgottenPasswordLink" @click="forgottenPasswordEvent">{{ $t('registration.forgotPassword') }}</a>

              <base-button class="continue-btn"
                           :disabled="!verificationMailInputFilled || buttonDisabled"
                           type="submit">
                {{ $t('common.continue') }}
              </base-button>
            </validation-observer>
          </div>
        </transition>
        <a class="back-to-side" href="#" @click.prevent="toggleFormSide('radioWrap')">
          <img class="back-arrow" src="/assets/images/mtel_small_arrow_left.png" alt=""> {{$t('common.back')}}
        </a>
      </div>
    </div>
    <div class="button-container">
      <base-button :disabled="!verificationMailInputFilled || buttonDisabled"
                   class="continue-btn"
                   @click="submitForm">
        {{ $t('common.continue') }}
      </base-button>
    </div>
  </div>
</template>

<script>
import OutlinedContainer from '@/components/common/outlined-container'
import debounce from '@/utils/debounce'
import { lsGet } from '@/utils/localStorageController'
import { addDataLayerEvent } from '@/services/dataLayer'
import { customRouter } from '@/customRouter'
import { addUserIdDataLayerEvent } from '@/utils/addUserIdDataLayerEvent'

export default {
  name: 'verification-email',
  components: { OutlinedContainer },
  data () {
    return {
      pickedMail: 'oldMail',
      email: '',
      token: '',
      activeFormSide: 'radioWrap',
      oldMailPassword: '',
      newMailPassword: '',
      oldMailSubmitted: false,
      newMailSubmitted: false,
      buttonDisabled: false
    }
  },
  computed: {
    forgottenPasswordLink () {
      return customRouter.getRouteByName({ name: 'forgottenPassword' })
    },
    verificationMailInputFilled () {
      if (this.pickedMail === 'newMail') return !!this.pickedMail && !!this.newMailPassword
      return !!this.pickedMail && !!this.oldMailPassword
    },
    activeSideClass () {
      return {
        'pass-side': this.activeFormSide === 'passwordWrap'
      }
    }
  },
  methods: {
    showRadioOrPassSide () {
      if (window.innerWidth >= 768) {
        this.activeFormSide = 'radioWrap'
      }
    },
    toggleFormSide (side) {
      this.activeFormSide = side
      this.$nextTick(() => {
        this.showRadioOrPassSide()
      })
    },
    async loginWithOldMail () {
      this.oldMailSubmitted = true
      this.buttonDisabled = true
      const valid = await this.$refs.emailVerOldMail.validate()

      if (valid) {
        this.$apiRequest.post('register/confirmpassword', { email: this.email, password: this.oldMailPassword, token: this.token })
          .then((response) => {
            if (response.status === 200) {
              this.$mvcRequest.post('users/authorize', { rememberMe: false, encodedPassword: this.oldMailPassword, userId: this.email })
                .then(response => {
                  this.buttonDisabled = false
                  if (response.status >= 200 && response.status < 400) {
                    addUserIdDataLayerEvent()
                    addDataLayerEvent({ event: 'login_successful' })
                    customRouter.goTo({ name: 'servicesOverview' })
                  }
                })
                .catch(e => {
                  this.toast('error', {
                    message: this.$t('errors.loginFail')
                  })
                  this.buttonDisabled = false
                })
              addDataLayerEvent('stari_nalog_logovanje')
            }
          })
          .catch(e => {
            if (e.response.data.errors[0].message === '' && e.response.data.errors[0].type === 'BadCredentialsError') {
              this.$refs.emailVerOldMail.setErrors({
                passwordOldMail: this.$t('errors.wrongPassword')
              })
            } else {
              this.$refs.emailVerOldMail.setErrors({
                passwordOldMail: e.response.data.errors[0].message
              })
            }
            addDataLayerEvent('neuspesna_lozinka')
          })
          .finally(() => {
            this.buttonDisabled = false
          })
      } else {
        this.buttonDisabled = false
      }
    },
    async loginWithNewMail () {
      this.newMailSubmitted = true
      this.buttonDisabled = true
      const valid = await this.$refs.emailVerNewMail.validate()

      if (valid) {
        this.$apiRequest.post('register/confirmpassword', { email: this.email, password: this.newMailPassword, token: this.token })
          .then((response) => {
            if (response.status === 200) {
              customRouter.goTo({ name: 'createAccount' })
              addDataLayerEvent('novi_nalog_logovanje')
            }
          })
          .catch(e => {
            if (e.response.data.errors && e.response.data.errors.length) {
              if (e.response.data.errors[0].message === '' && e.response.data.errors[0].type === 'BadCredentialsError') {
                this.$refs.emailVerNewMail.setErrors({
                  passwordNewMail: this.$t('errors.wrongPassword')
                })
              } else if (e.response.data.errors[0].message === '' && e.response.data.errors[0].type === 'MtmInvalidRegistrationTokenError') {
                this.toast('error', {
                  message: this.$t('errors.defaultError')
                })
              } else {
                this.$refs.emailVerNewMail.setErrors({
                  passwordNewMail: e.response.data.errors[0].message
                })
              }
            }
            this.buttonDisabled = false
            addDataLayerEvent('neuspesna_lozinka')
          })
      }
    },
    submitForm () {
      if (this.pickedMail === 'oldMail') {
        this.loginWithOldMail()
      } else if (this.pickedMail === 'newMail') {
        this.loginWithNewMail()
      }
    },
    localStorageDataValid (data) {
      return data && data.email && data.registered && data.token && data.type
    },
    forgottenPasswordEvent () {
      addDataLayerEvent('zaboravljena_lozinka')
    }
  },
  watch: {
    pickedMail () {
      this.oldMailPassword = ''
      this.newMailPassword = ''
    }
  },
  mounted () {
    const registrationData = lsGet('sc_registration')

    if (this.localStorageDataValid(registrationData)) {
      this.email = registrationData.email
      this.token = registrationData.token

      this.$emit('data-fetched', { email: registrationData.email, phoneNumber: registrationData.phoneNumber })
    } else {
      // if data in LS is not valid, return user to registration page
      customRouter.goTo({ name: 'registration' })
    }

    window.addEventListener('resize', () => debounce(this.showRadioOrPassSide, 10))
  }
}
</script>

<style scoped lang="scss" src="./registration-comp-styles/verification-email.scss"></style>
